/* PDP carousels - OD's Designer Clothing
   FROM THE BRAND    : same brand + same category + same gender
   YOU MAY ALSO LIKE : same category + same gender + every OTHER brand
   Hero shot, in stock, current product excluded. One request per row. */
(function () {
  var SECTION = 'pdp-brand-feed';
  var MAX = 16;

  function load(slot, params, self, excludeVendor) {
    var host = document.querySelector('[data-pdpc-list="' + slot + '"]');
    var sectionEl = host && host.closest('[data-pdpc-section]');
    if (!host || !sectionEl) return;

    var u = '/collections/all?section_id=' + SECTION + '&filter.v.availability=1';
    params.forEach(function (p) { u += '&' + p[0] + '=' + encodeURIComponent(p[1]); });

    fetch(u, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) throw 0;
        var feed = new DOMParser().parseFromString(html, 'text/html').querySelector('.pdpc-feed');
        if (!feed) throw 0;

        // Same-brand cards are removed here rather than with a vendor filter:
        // listing 60+ vendors in the URL makes Shopify 404 it.
        if (excludeVendor) {
          feed.querySelectorAll('.pdpc-card').forEach(function (c) {
            var v = c.querySelector('.pdpc-card__vendor');
            if (v && v.textContent.trim() === excludeVendor) {
              var s2 = c.closest('.resource-list__slide') || c.closest('.resource-list__item');
              if (s2) s2.remove();
            }
          });
        }

        // Drop this product from its own row. Links carry ?variant=&_pos=.
        feed.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          if (a.getAttribute('href').split('?')[0].replace(/\/$/, '') !== '/products/' + self) return;
          var s = a.closest('.resource-list__slide') || a.closest('.resource-list__item');
          if (s) s.remove();
        });

        var slides = feed.querySelectorAll('.resource-list__slide');
        if (!slides.length) slides = feed.querySelectorAll('.resource-list__item');
        for (var i = MAX; i < slides.length; i++) slides[i].remove();

        if (!feed.querySelector('.resource-list__item')) throw 0;
        host.replaceChildren(feed);
        sectionEl.removeAttribute('hidden');
      })
      .catch(function () { sectionEl.remove(); });
  }

  function boot() {
    var root = document.querySelector('[data-pdpc-root]');
    if (!root) return;

    var vendor = root.dataset.pdpcVendor;
    var type = root.dataset.pdpcType;
    var self = root.dataset.pdpcHandle;
    var genders = (root.dataset.pdpcGenders || '').split(',').filter(Boolean);

    if (!vendor || !type || !genders.length) {
      document.querySelectorAll('[data-pdpc-section]').forEach(function (s) { s.remove(); });
      return;
    }

    // Strict = this product's own gender(s), unisex stripped.
    var strict = [];
    genders.forEach(function (g) { if (g !== 'gender_unisex') strict.push(['filter.p.tag', g]); });

    // FROM THE BRAND also accepts unisex stock; the other row does not.
    var loose = strict.slice();
    loose.push(['filter.p.tag', 'gender_unisex']);

    load('brand', [['filter.p.vendor', vendor], ['filter.p.product_type', type]].concat(loose), self);

    // A unisex-only product gets FROM THE BRAND and nothing else.
    if (!strict.length) {
      var h0 = document.querySelector('[data-pdpc-list="also"]');
      var s0 = h0 && h0.closest('[data-pdpc-section]');
      if (s0) s0.remove();
      return;
    }

    // YOU MAY ALSO LIKE - same category, other brands (filtered client-side)
    load('also', [['filter.p.product_type', type]].concat(strict), self, vendor);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();
